import { FC } from "react";

const GradientDividerIcon: FC<React.SVGProps<SVGSVGElement>> = ({
  width = "328",
  height = "1",
  ...props
}) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={width}
    height={height}
    viewBox="0 0 328 1"
    fill="none"
    preserveAspectRatio="none"
    {...props}
  >
    <path
      d="M0.5 0.5H327.5"
      stroke="url(#paint0_linear_gradient_divider)"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear_gradient_divider"
        x1="0.5"
        y1="1"
        x2="327.5"
        y2="1"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#D1D5DB" stopOpacity="0" />
        <stop offset="0.53119" stopColor="#D1D5DB" />
        <stop offset="1" stopColor="#D1D5DB" stopOpacity="0" />
      </linearGradient>
    </defs>
  </svg>
);

export default GradientDividerIcon;
